var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"font-bold text-lg md:text-2xl py-2 font-display text-gray-700"},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }